import isEmpty from 'lodash/isEmpty';
import FormInputText from 'molecules/FormField/FormInputText';
import NotificationAlert, { Notification } from 'molecules/NotificationAlert';
import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { validateEmail } from 'utils/errorUtils';
import useFormSubmit from 'utils/hooks/useFormSubmit';

import s from './Footer.module.scss';

const NEWSLETTER_FORM_ID = 'ad18c1-891a-470a-be56-4718b545af2b';

const Newsletter = () => {
  const {
    control,
    handleSubmit,
    setError,
    setValue,
    formState: { errors }
  } = useForm();

  const { submitForm } = useFormSubmit();
  const [notification, setNotification] = useState<Notification | undefined>();
  const [isDisabled, setIsDisabled] = useState(false);

  const onSubmit = (data: Record<string, string>) => {
    if (!isEmpty(errors) || !data.email) return;

    if (!validateEmail(data.email)) {
      setError('email', {
        type: 'manual',
        message: 'Please enter a valid email'
      });
      return;
    }

    setIsDisabled(true);
    submitForm(
      NEWSLETTER_FORM_ID,
      data,
      () => {
        setIsDisabled(false);
        setNotification({ type: 'success', message: 'Thank you for your subscription.' });
        setValue('email', '');
      },
      (errors) => {
        setIsDisabled(false);
        setNotification({
          type: 'warning',
          message: 'Something went wrong. Please try again later.'
        });
      }
    );
  };

  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)} className={s.Footer__form}>
        <FormInputText
          type="email"
          name="register"
          control={control}
          description=""
          variant="filled"
          className={s.Footer__input}
          TextFieldProps={{ hiddenLabel: true, placeholder: 'Your email here...' }}
        />
        <button type="submit" className={s.Footer__submit} disabled={isDisabled}>
          {'Subscribe'}
        </button>
      </form>
      <NotificationAlert
        open={!!notification}
        severity={notification?.type}
        onClose={() => setNotification(undefined)}
      >
        {notification?.message}
      </NotificationAlert>
    </>
  );
};

export default Newsletter;
